
import Vue from "vue";
import Component from "vue-class-component";
import filters from "@/filters";
import { Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
import { download, downloadBlob } from "@/functions/global.function";
import { AxiosResponse } from "axios";

@Component({
  components: {},
  filters,
})
export default class MyCourseCertificate extends Vue {
  @Action("getCertificate", { namespace: "myCourse" })
  private getCertificate: any;

  @Prop({ default: 1 })
  private step!: number;
  @Prop({ default: 1 })
  private maxSteps!: number;
  @Prop({ default: null })
  private course!: any;

  private get isLastStep() {
    return this.step === this.maxSteps;
  }

  private prev() {
    if (this.step === 1) return;
    this.$emit("nextStep", this.step - 1);
  }

  private next() {
    this.$emit("nextStep", this.step + 1);
  }

  private downloadCertificate() {
    this.getCertificate({
      params: {
        id: this.course?.id,
      },
      success: (response: AxiosResponse) => {
        downloadBlob(response.data, "Certificate.pdf");
      },
    });
    // download(this.course?.certificate?.attachment, "Certificate.pdf");
  }
}
